import React from 'react';
import { Icons } from '@Assets/SvgIcons';
import { ICTask } from '@Helper/Interfaces';
import { MergefloColors } from '@Helper/MergefloColors';
import { getAssets } from '@Store/feature/assetsSlice';
import { useAppSelector } from '@Store/hooks';
import { FunctionalArea } from '@/pages/authentication/CreateDealspace';
import './DependencyItem.scss';


export type DependencyItemProps = {
  task: ICTask;
  sourceName?: string;
  style?: React.CSSProperties; 
}

const DependencyItem = ({ 
  task, sourceName = 'shortName', 
  style = { marginRight: 10 },
}: DependencyItemProps) => {
  const mergefloColors = new MergefloColors();
  const { functionalAreas } = useAppSelector(getAssets);
  const dependencyTarget = functionalAreas?.find(({ id }) => id === task.dependencyTarget);
  const dependencySource = functionalAreas?.find(({ id }) => id === task.dependencySource);
  const sourceType = sourceName as keyof FunctionalArea;

  if (!dependencyTarget && !dependencySource) {
    return (<></>);
  }

  return (
    <div
      className="dependency-item"
      style={{
        ...style,
        backgroundColor: mergefloColors.getPlaybookColor(
          dependencyTarget?.shortName ?? ''
        )
    }}
    >
      <span style={{ marginRight: 5 }}>
        {dependencySource && dependencySource[sourceType]}
      </span>
      <Icons.ArrowDown color="#ffffff" />
      <span style={{ marginLeft: 5 }}>
        {dependencyTarget && dependencyTarget[sourceType]}
      </span>
    </div>
  );
};


export default DependencyItem;
